module.exports = __webpack_public_path__ + "d94e20c1/img/chevron-right-icon.253a4260.svg";